<template lang='pug'>
v-app#page3_3(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page3-2')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero saber cómo me protege un Crédito Hipotecario!
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA
            v-card-text.titulo24Reg.mx-2.px-0.pt-4.pb-0.mb-0
              | Selecciona las palabras a los espacios vacíos para que el texto refleje tu percepción de ese futuro de la mejor manera posible. 
            v-card.questionCard.mx-4(justify-center, flat)
              v-layout(row, justify-center)
                v-flex.py-2.my-3(align-content-center)
                  p.titulo18Book.text-xs-left.px-5.py-0.my-0(style='line-height: 80px;')
                    span(v-for="reactivo in reactivos")
                      span.px-2
                        | {{reactivo.pregunta}}
                      span
                        v-icon.pr-2(v-if='sent && (reactivo.resultado==1)' size='15px', color='green') fas fa-check
                        v-icon.pr-2(v-if='sent && (reactivo.resultado==0)' size='15px', color='red ') fas fa-times
                      span.selector
                        v-select(v-if='show' :items='reactivo.opciones'  v-model='reactivo.respuesta' label='Selecciona...' solo  height='59')
                    span.px-2
                      | el inmueble.
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled='!completed', @click=' sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          div(v-if='sent && (resultado==1) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                          div(v-if='sent && (resultado!=1) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                          v-spacer.my-1.py-4
                          div(v-if='sent && (resultado==1) ')
                            v-card-text.headline
                              | ¡Bien!
                            v-card.questionCard(justify-center, flat)
                              v-card-text.text-xs-left.px-5
                                b ¡Tienes toda la razón! 
                                |  Tu percepción es correcta. La contratación de un Crédito Hipotecario conlleva un compromiso de por lo menos 10 años, 
                                |  plazo en el cual pueden suceder eventos inesperados. Por ello, las partes contratantes deben estar prevenidas.
                              v-card-text.text-xs-left.px-5
                                | Al contratar un 
                                b  Crédito Hipotecario, 
                                |  adquieres también 
                                b  seguros 
                                |  que te protegerán a ti y a tu familia.
                              v-card-text.text-xs-left.px-5
                                b Seguros obligatorios:
                                ul 
                                  li 
                                    b Vida
                                  li 
                                    b Desempleo
                                  li 
                                    b Daños
                                  li 
                                    b Contenidos
                                  li 
                                    b Invalidez
                              v-card-text.text-xs-left.px-5
                                | Pero, ¿cómo se integran estos seguros a tu Crédito Hipotecario? ¿Cómo se activan en caso de ser necesario? 
                                |  ¡Lo averiguarás en la siguiente actividad!
                          div(v-if='sent && (resultado!=1) ')
                            v-card-text.headline
                              | Hay una mejor respuesta...
                            v-card.questionCard(justify-center, flat)
                              v-card-text.text-xs-left.px-5
                                b ¿Estás seguro? 
                                |  ¡Te invitamos a cambiar tu percepción! 
                                |  Considera que la contratación de un Crédito Hipotecario significa un compromiso de por lo menos 10 años, 
                                |  plazo en el cual pueden suceder eventos inesperados. Por ello, las partes contratantes deben estar prevenidas.
                              v-card-text.text-xs-left.px-5
                                | Al contratar un 
                                b  Crédito Hipotecario, 
                                |  adquieres también 
                                b  seguros 
                                |  que te protegerán a ti y a tu familia.
                              v-card-text.text-xs-left.px-5
                                b Seguros obligatorios:
                                ul 
                                  li 
                                    b Vida
                                  li 
                                    b Desempleo
                                  li 
                                    b Daños
                                  li 
                                    b Contenidos
                                  li 
                                    b Invalidez
                              v-card-text.text-xs-left.px-5
                                | Pero, ¿cómo se integran estos seguros a tu Crédito Hipotecario? ¿Cómo se activan en caso de ser necesario? 
                                |  ¡Lo averiguarás en la siguiente actividad!
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page4-1') ")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}
export default {
  name: 'app',
  data() {
    return {
      dialog: false,
      resultado: 0,
      response: 'none',
      sent: false,
      show: false,
      reactivos: [{
          pregunta: 'Adquirir un Crédito Hipotecario es un compromiso a',
          correctas: [
            'largo'
          ],
          opciones: [
            'corto',
            'largo'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'plazo. En este tiempo, muchas cosas pueden pasar.',
          correctas: [
            'Existen'
          ],
          opciones: [
            'Existen',
            'No existen'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'mecanismos como los seguros que toman en cuenta estos eventos inesperados. Si llego a perder mi empleo, quedaré',
          correctas: [
            'protegido'
          ],
          opciones: [
            'protegido',
            'desamparado'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'y si llego a fallecer, mi familia',
          correctas: [
            'conservará'
          ],
          opciones: [
            'conservará',
            'perderá'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        }
      ],
      opciones: [
        "Co-financiamiento", "Crédito Bancario", "INFONAVIT", "FOVISSTE", "Sofol"
      ]
    }
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correctas.includes(reactivo.respuesta)) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  beforeMount: function() {
    shuffle(this.opciones);
  },
  beforeUpdate: function() {
    var opciones = this.opciones;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          opciones.push(reactivo.respuesta.shift());
        } else {
          opciones.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  computed: {
    completed() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == "") {
          complete = false;
        }
      });
      return complete;
    },
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  },
  created() {
    console.log('GLOBAL SERVICE: created')
    let service = this.$dragula.$service
    // IMPORTANT!! setup empty named drakes matching
    // directive drake configs in template
    // otherwise may (currently) result in conflict
    service.options('second', {})
    console.log('GLOBAL SERVICE: ready')
    window.setInterval(() => {
      this.show = true;
    },1500);
  }
};
</script>
